import React, { useEffect } from "react";
import { changeQuery } from "../../containers/Map.action";
import { MapContext } from "../../containers/Map.context";
import "./SearchBox.scss";

const SearchBox = (props: React.PropsWithChildren<any>) => {
  const { state, dispatch } = React.useContext(MapContext);

  // Event handler to return input string value
  const handler = (event: React.SyntheticEvent<EventTarget>): void => {
    const target = event.target;

    if (!(target instanceof window.HTMLInputElement)) {
      return;
    }
    const action = changeQuery(target.value);
    dispatch(action);
  };

  useEffect(() => {
    if (!state.query) {
      const input: HTMLInputElement | null = document.querySelector(
        ".searchInput"
      );
      if (input) {
        input.value = "";
      }
    }
  }, [state.query]);

  return (
    <div className="input-group w-25" id="searchBox">
      <input
        type="text"
        className="form-control searchInput"
        placeholder="Find Branch"
        onChange={handler}
      />
    </div>
  );
};

export default SearchBox;
